import React from "react";
import PatientPrescriptionTable from "../../../components/patient-side-components/patient-prescription-table/PatientPrescriptionTable";

const PatientPrescription = () => {
  return (
    <div className="flex w-full items-center justify-center flex-col relative">
      <PatientPrescriptionTable />
    </div>
  );
};

export default PatientPrescription;
